const fallbackImage =
  'data:image/png;base64,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';
export { fallbackImage };

export function getOrdinalSuffix(number) {
  const remainderTen = number % 10;
  const remainderHundred = number % 100;

  // Special case for 11, 12, and 13
  if (remainderHundred >= 11 && remainderHundred <= 13) {
    return `${number}th`;
  }

  // General cases
  switch (remainderTen) {
    case 1:
      return `${number}st`;
    case 2:
      return `${number}nd`;
    case 3:
      return `${number}rd`;
    default:
      return `${number}th`;
  }
}

export function formatNumberToShort(num) {
  if (num >= 1000000) {
    const millions = (num / 1000000).toFixed(1);
    return millions.endsWith('.0') ? `${millions.slice(0, -2)}M` : `${millions}M`;
  }
  if (num >= 1000) {
    const thousands = (num / 1000).toFixed(1);
    return thousands.endsWith('.0') ? `${thousands.slice(0, -2)}k` : `${thousands}k`;
  }
  return num.toString();
}

export const countryData = [
  {
    country: 'Afghanistan',
    iso2: 'AF',
    iso3: 'AFG',
    numeric: '004',
  },
  {
    country: 'Albania',
    iso2: 'AL',
    iso3: 'ALB',
    numeric: '008',
  },
  {
    country: 'Algeria',
    iso2: 'DZ',
    iso3: 'DZA',
    numeric: '012',
  },
  {
    country: 'American Samoa',
    iso2: 'AS',
    iso3: 'ASM',
    numeric: '016',
  },
  {
    country: 'Andorra',
    iso2: 'AD',
    iso3: 'AND',
    numeric: '020',
  },
  {
    country: 'Angola',
    iso2: 'AO',
    iso3: 'AGO',
    numeric: '024',
  },
  {
    country: 'Anguilla',
    iso2: 'AI',
    iso3: 'AIA',
    numeric: '660',
  },
  {
    country: 'Antarctica',
    iso2: 'AQ',
    iso3: 'ATA',
    numeric: '010',
  },
  {
    country: 'Antigua and Barbuda',
    iso2: 'AG',
    iso3: 'ATG',
    numeric: '028',
  },
  {
    country: 'Argentina',
    iso2: 'AR',
    iso3: 'ARG',
    numeric: '032',
  },
  {
    country: 'Armenia',
    iso2: 'AM',
    iso3: 'ARM',
    numeric: '051',
  },
  {
    country: 'Aruba',
    iso2: 'AW',
    iso3: 'ABW',
    numeric: '533',
  },
  {
    country: 'Australia',
    iso2: 'AU',
    iso3: 'AUS',
    numeric: '036',
  },
  {
    country: 'Austria',
    iso2: 'AT',
    iso3: 'AUT',
    numeric: '040',
  },
  {
    country: 'Azerbaijan',
    iso2: 'AZ',
    iso3: 'AZE',
    numeric: '031',
  },
  {
    country: 'Bahamas (the)',
    iso2: 'BS',
    iso3: 'BHS',
    numeric: '044',
  },
  {
    country: 'Bahrain',
    iso2: 'BH',
    iso3: 'BHR',
    numeric: '048',
  },
  {
    country: 'Bangladesh',
    iso2: 'BD',
    iso3: 'BGD',
    numeric: '050',
  },
  {
    country: 'Barbados',
    iso2: 'BB',
    iso3: 'BRB',
    numeric: '052',
  },
  {
    country: 'Belarus',
    iso2: 'BY',
    iso3: 'BLR',
    numeric: '112',
  },
  {
    country: 'Belgium',
    iso2: 'BE',
    iso3: 'BEL',
    numeric: '056',
  },
  {
    country: 'Belize',
    iso2: 'BZ',
    iso3: 'BLZ',
    numeric: '084',
  },
  {
    country: 'Benin',
    iso2: 'BJ',
    iso3: 'BEN',
    numeric: '204',
  },
  {
    country: 'Bermuda',
    iso2: 'BM',
    iso3: 'BMU',
    numeric: '060',
  },
  {
    country: 'Bhutan',
    iso2: 'BT',
    iso3: 'BTN',
    numeric: '064',
  },
  {
    country: 'Bolivia (Plurinational State of)',
    iso2: 'BO',
    iso3: 'BOL',
    numeric: '068',
  },
  {
    country: 'Bonaire, Sint Eustatius and Saba',
    iso2: 'BQ',
    iso3: 'BES',
    numeric: '535',
  },
  {
    country: 'Bosnia and Herzegovina',
    iso2: 'BA',
    iso3: 'BIH',
    numeric: '070',
  },
  {
    country: 'Botswana',
    iso2: 'BW',
    iso3: 'BWA',
    numeric: '072',
  },
  {
    country: 'Bouvet Island',
    iso2: 'BV',
    iso3: 'BVT',
    numeric: '074',
  },
  {
    country: 'Brazil',
    iso2: 'BR',
    iso3: 'BRA',
    numeric: '076',
  },
  {
    country: 'British Indian Ocean Territory (the)',
    iso2: 'IO',
    iso3: 'IOT',
    numeric: '086',
  },
  {
    country: 'Brunei Darussalam',
    iso2: 'BN',
    iso3: 'BRN',
    numeric: '096',
  },
  {
    country: 'Bulgaria',
    iso2: 'BG',
    iso3: 'BGR',
    numeric: '100',
  },
  {
    country: 'Burkina Faso',
    iso2: 'BF',
    iso3: 'BFA',
    numeric: '854',
  },
  {
    country: 'Burundi',
    iso2: 'BI',
    iso3: 'BDI',
    numeric: '108',
  },
  {
    country: 'Cabo Verde',
    iso2: 'CV',
    iso3: 'CPV',
    numeric: '132',
  },
  {
    country: 'Cambodia',
    iso2: 'KH',
    iso3: 'KHM',
    numeric: '116',
  },
  {
    country: 'Cameroon',
    iso2: 'CM',
    iso3: 'CMR',
    numeric: '120',
  },
  {
    country: 'Canada',
    iso2: 'CA',
    iso3: 'CAN',
    numeric: '124',
  },
  {
    country: 'Cayman Islands (the)',
    iso2: 'KY',
    iso3: 'CYM',
    numeric: '136',
  },
  {
    country: 'Central African Republic (the)',
    iso2: 'CF',
    iso3: 'CAF',
    numeric: '140',
  },
  {
    country: 'Chad',
    iso2: 'TD',
    iso3: 'TCD',
    numeric: '148',
  },
  {
    country: 'Chile',
    iso2: 'CL',
    iso3: 'CHL',
    numeric: '152',
  },
  {
    country: 'China',
    iso2: 'CN',
    iso3: 'CHN',
    numeric: '156',
  },
  {
    country: 'Christmas Island',
    iso2: 'CX',
    iso3: 'CXR',
    numeric: '162',
  },
  {
    country: 'Cocos (Keeling) Islands (the)',
    iso2: 'CC',
    iso3: 'CCK',
    numeric: '166',
  },
  {
    country: 'Colombia',
    iso2: 'CO',
    iso3: 'COL',
    numeric: '170',
  },
  {
    country: 'Comoros (the)',
    iso2: 'KM',
    iso3: 'COM',
    numeric: '174',
  },
  {
    country: 'Congo (the Democratic Republic of the)',
    iso2: 'CD',
    iso3: 'COD',
    numeric: '180',
  },
  {
    country: 'Congo (the)',
    iso2: 'CG',
    iso3: 'COG',
    numeric: '178',
  },
  {
    country: 'Cook Islands (the)',
    iso2: 'CK',
    iso3: 'COK',
    numeric: '184',
  },
  {
    country: 'Costa Rica',
    iso2: 'CR',
    iso3: 'CRI',
    numeric: '188',
  },
  {
    country: "C&ocirc;te d'Ivoire",
    iso2: 'CI',
    iso3: 'CIV',
    numeric: '384',
  },
  {
    country: 'Croatia',
    iso2: 'HR',
    iso3: 'HRV',
    numeric: '191',
  },
  {
    country: 'Cuba',
    iso2: 'CU',
    iso3: 'CUB',
    numeric: '192',
  },
  {
    country: 'Cura&ccedil;ao',
    iso2: 'CW',
    iso3: 'CUW',
    numeric: '531',
  },
  {
    country: 'Cyprus',
    iso2: 'CY',
    iso3: 'CYP',
    numeric: '196',
  },
  {
    country: 'Czechia',
    iso2: 'CZ',
    iso3: 'CZE',
    numeric: '203',
  },
  {
    country: 'Denmark',
    iso2: 'DK',
    iso3: 'DNK',
    numeric: '208',
  },
  {
    country: 'Djibouti',
    iso2: 'DJ',
    iso3: 'DJI',
    numeric: '262',
  },
  {
    country: 'Dominica',
    iso2: 'DM',
    iso3: 'DMA',
    numeric: '212',
  },
  {
    country: 'Dominican Republic (the)',
    iso2: 'DO',
    iso3: 'DOM',
    numeric: '214',
  },
  {
    country: 'Ecuador',
    iso2: 'EC',
    iso3: 'ECU',
    numeric: '218',
  },
  {
    country: 'Egypt',
    iso2: 'EG',
    iso3: 'EGY',
    numeric: '818',
  },
  {
    country: 'El Salvador',
    iso2: 'SV',
    iso3: 'SLV',
    numeric: '222',
  },
  {
    country: 'Equatorial Guinea',
    iso2: 'GQ',
    iso3: 'GNQ',
    numeric: '226',
  },
  {
    country: 'Eritrea',
    iso2: 'ER',
    iso3: 'ERI',
    numeric: '232',
  },
  {
    country: 'Estonia',
    iso2: 'EE',
    iso3: 'EST',
    numeric: '233',
  },
  {
    country: 'Eswatini',
    iso2: 'SZ',
    iso3: 'SWZ',
    numeric: '748',
  },
  {
    country: 'Ethiopia',
    iso2: 'ET',
    iso3: 'ETH',
    numeric: '231',
  },
  {
    country: 'Falkland Islands (the) [Malvinas]',
    iso2: 'FK',
    iso3: 'FLK',
    numeric: '238',
  },
  {
    country: 'Faroe Islands (the)',
    iso2: 'FO',
    iso3: 'FRO',
    numeric: '234',
  },
  {
    country: 'Fiji',
    iso2: 'FJ',
    iso3: 'FJI',
    numeric: '242',
  },
  {
    country: 'Finland',
    iso2: 'FI',
    iso3: 'FIN',
    numeric: '246',
  },
  {
    country: 'France',
    iso2: 'FR',
    iso3: 'FRA',
    numeric: '250',
  },
  {
    country: 'French Guiana',
    iso2: 'GF',
    iso3: 'GUF',
    numeric: '254',
  },
  {
    country: 'French Polynesia',
    iso2: 'PF',
    iso3: 'PYF',
    numeric: '258',
  },
  {
    country: 'French Southern Territories (the)',
    iso2: 'TF',
    iso3: 'ATF',
    numeric: '260',
  },
  {
    country: 'Gabon',
    iso2: 'GA',
    iso3: 'GAB',
    numeric: '266',
  },
  {
    country: 'Gambia (the)',
    iso2: 'GM',
    iso3: 'GMB',
    numeric: '270',
  },
  {
    country: 'Georgia',
    iso2: 'GE',
    iso3: 'GEO',
    numeric: '268',
  },
  {
    country: 'Germany',
    iso2: 'DE',
    iso3: 'DEU',
    numeric: '276',
  },
  {
    country: 'Ghana',
    iso2: 'GH',
    iso3: 'GHA',
    numeric: '288',
  },
  {
    country: 'Gibraltar',
    iso2: 'GI',
    iso3: 'GIB',
    numeric: '292',
  },
  {
    country: 'Greece',
    iso2: 'GR',
    iso3: 'GRC',
    numeric: '300',
  },
  {
    country: 'Greenland',
    iso2: 'GL',
    iso3: 'GRL',
    numeric: '304',
  },
  {
    country: 'Grenada',
    iso2: 'GD',
    iso3: 'GRD',
    numeric: '308',
  },
  {
    country: 'Guadeloupe',
    iso2: 'GP',
    iso3: 'GLP',
    numeric: '312',
  },
  {
    country: 'Guam',
    iso2: 'GU',
    iso3: 'GUM',
    numeric: '316',
  },
  {
    country: 'Guatemala',
    iso2: 'GT',
    iso3: 'GTM',
    numeric: '320',
  },
  {
    country: 'Guernsey',
    iso2: 'GG',
    iso3: 'GGY',
    numeric: '831',
  },
  {
    country: 'Guinea',
    iso2: 'GN',
    iso3: 'GIN',
    numeric: '324',
  },
  {
    country: 'Guinea-Bissau',
    iso2: 'GW',
    iso3: 'GNB',
    numeric: '624',
  },
  {
    country: 'Guyana',
    iso2: 'GY',
    iso3: 'GUY',
    numeric: '328',
  },
  {
    country: 'Haiti',
    iso2: 'HT',
    iso3: 'HTI',
    numeric: '332',
  },
  {
    country: 'Heard Island and McDonald Islands',
    iso2: 'HM',
    iso3: 'HMD',
    numeric: '334',
  },
  {
    country: 'Holy See (the)',
    iso2: 'VA',
    iso3: 'VAT',
    numeric: '336',
  },
  {
    country: 'Honduras',
    iso2: 'HN',
    iso3: 'HND',
    numeric: '340',
  },
  {
    country: 'Hong Kong',
    iso2: 'HK',
    iso3: 'HKG',
    numeric: '344',
  },
  {
    country: 'Hungary',
    iso2: 'HU',
    iso3: 'HUN',
    numeric: '348',
  },
  {
    country: 'Iceland',
    iso2: 'IS',
    iso3: 'ISL',
    numeric: '352',
  },
  {
    country: 'India',
    iso2: 'IN',
    iso3: 'IND',
    numeric: '356',
  },
  {
    country: 'Indonesia',
    iso2: 'ID',
    iso3: 'IDN',
    numeric: '360',
  },
  {
    country: 'Iran (Islamic Republic of)',
    iso2: 'IR',
    iso3: 'IRN',
    numeric: '364',
  },
  {
    country: 'Iraq',
    iso2: 'IQ',
    iso3: 'IRQ',
    numeric: '368',
  },
  {
    country: 'Ireland',
    iso2: 'IE',
    iso3: 'IRL',
    numeric: '372',
  },
  {
    country: 'Isle of Man',
    iso2: 'IM',
    iso3: 'IMN',
    numeric: '833',
  },
  {
    country: 'Israel',
    iso2: 'IL',
    iso3: 'ISR',
    numeric: '376',
  },
  {
    country: 'Italy',
    iso2: 'IT',
    iso3: 'ITA',
    numeric: '380',
  },
  {
    country: 'Jamaica',
    iso2: 'JM',
    iso3: 'JAM',
    numeric: '388',
  },
  {
    country: 'Japan',
    iso2: 'JP',
    iso3: 'JPN',
    numeric: '392',
  },
  {
    country: 'Jersey',
    iso2: 'JE',
    iso3: 'JEY',
    numeric: '832',
  },
  {
    country: 'Jordan',
    iso2: 'JO',
    iso3: 'JOR',
    numeric: '400',
  },
  {
    country: 'Kazakhstan',
    iso2: 'KZ',
    iso3: 'KAZ',
    numeric: '398',
  },
  {
    country: 'Kenya',
    iso2: 'KE',
    iso3: 'KEN',
    numeric: '404',
  },
  {
    country: 'Kiribati',
    iso2: 'KI',
    iso3: 'KIR',
    numeric: '296',
  },
  {
    country: "Korea (the Democratic People's Republic of)",
    iso2: 'KP',
    iso3: 'PRK',
    numeric: '408',
  },
  {
    country: 'Korea (the Republic of)',
    iso2: 'KR',
    iso3: 'KOR',
    numeric: '410',
  },
  {
    country: 'Kuwait',
    iso2: 'KW',
    iso3: 'KWT',
    numeric: '414',
  },
  {
    country: 'Kyrgyzstan',
    iso2: 'KG',
    iso3: 'KGZ',
    numeric: '417',
  },
  {
    country: "Lao People's Democratic Republic (the)",
    iso2: 'LA',
    iso3: 'LAO',
    numeric: '418',
  },
  {
    country: 'Latvia',
    iso2: 'LV',
    iso3: 'LVA',
    numeric: '428',
  },
  {
    country: 'Lebanon',
    iso2: 'LB',
    iso3: 'LBN',
    numeric: '422',
  },
  {
    country: 'Lesotho',
    iso2: 'LS',
    iso3: 'LSO',
    numeric: '426',
  },
  {
    country: 'Liberia',
    iso2: 'LR',
    iso3: 'LBR',
    numeric: '430',
  },
  {
    country: 'Libya',
    iso2: 'LY',
    iso3: 'LBY',
    numeric: '434',
  },
  {
    country: 'Liechtenstein',
    iso2: 'LI',
    iso3: 'LIE',
    numeric: '438',
  },
  {
    country: 'Lithuania',
    iso2: 'LT',
    iso3: 'LTU',
    numeric: '440',
  },
  {
    country: 'Luxembourg',
    iso2: 'LU',
    iso3: 'LUX',
    numeric: '442',
  },
  {
    country: 'Macao',
    iso2: 'MO',
    iso3: 'MAC',
    numeric: '446',
  },
  {
    country: 'Republic of North Macedonia',
    iso2: 'MK',
    iso3: 'MKD',
    numeric: '807',
  },
  {
    country: 'Madagascar',
    iso2: 'MG',
    iso3: 'MDG',
    numeric: '450',
  },
  {
    country: 'Malawi',
    iso2: 'MW',
    iso3: 'MWI',
    numeric: '454',
  },
  {
    country: 'Malaysia',
    iso2: 'MY',
    iso3: 'MYS',
    numeric: '458',
  },
  {
    country: 'Maldives',
    iso2: 'MV',
    iso3: 'MDV',
    numeric: '462',
  },
  {
    country: 'Mali',
    iso2: 'ML',
    iso3: 'MLI',
    numeric: '466',
  },
  {
    country: 'Malta',
    iso2: 'MT',
    iso3: 'MLT',
    numeric: '470',
  },
  {
    country: 'Marshall Islands (the)',
    iso2: 'MH',
    iso3: 'MHL',
    numeric: '584',
  },
  {
    country: 'Martinique',
    iso2: 'MQ',
    iso3: 'MTQ',
    numeric: '474',
  },
  {
    country: 'Mauritania',
    iso2: 'MR',
    iso3: 'MRT',
    numeric: '478',
  },
  {
    country: 'Mauritius',
    iso2: 'MU',
    iso3: 'MUS',
    numeric: '480',
  },
  {
    country: 'Mayotte',
    iso2: 'YT',
    iso3: 'MYT',
    numeric: '175',
  },
  {
    country: 'Mexico',
    iso2: 'MX',
    iso3: 'MEX',
    numeric: '484',
  },
  {
    country: 'Micronesia (Federated States of)',
    iso2: 'FM',
    iso3: 'FSM',
    numeric: '583',
  },
  {
    country: 'Moldova (the Republic of)',
    iso2: 'MD',
    iso3: 'MDA',
    numeric: '498',
  },
  {
    country: 'Monaco',
    iso2: 'MC',
    iso3: 'MCO',
    numeric: '492',
  },
  {
    country: 'Mongolia',
    iso2: 'MN',
    iso3: 'MNG',
    numeric: '496',
  },
  {
    country: 'Montenegro',
    iso2: 'ME',
    iso3: 'MNE',
    numeric: '499',
  },
  {
    country: 'Montserrat',
    iso2: 'MS',
    iso3: 'MSR',
    numeric: '500',
  },
  {
    country: 'Morocco',
    iso2: 'MA',
    iso3: 'MAR',
    numeric: '504',
  },
  {
    country: 'Mozambique',
    iso2: 'MZ',
    iso3: 'MOZ',
    numeric: '508',
  },
  {
    country: 'Myanmar',
    iso2: 'MM',
    iso3: 'MMR',
    numeric: '104',
  },
  {
    country: 'Namibia',
    iso2: 'NA',
    iso3: 'NAM',
    numeric: '516',
  },
  {
    country: 'Nauru',
    iso2: 'NR',
    iso3: 'NRU',
    numeric: '520',
  },
  {
    country: 'Nepal',
    iso2: 'NP',
    iso3: 'NPL',
    numeric: '524',
  },
  {
    country: 'Netherlands (the)',
    iso2: 'NL',
    iso3: 'NLD',
    numeric: '528',
  },
  {
    country: 'New Caledonia',
    iso2: 'NC',
    iso3: 'NCL',
    numeric: '540',
  },
  {
    country: 'New Zealand',
    iso2: 'NZ',
    iso3: 'NZL',
    numeric: '554',
  },
  {
    country: 'Nicaragua',
    iso2: 'NI',
    iso3: 'NIC',
    numeric: '558',
  },
  {
    country: 'Niger (the)',
    iso2: 'NE',
    iso3: 'NER',
    numeric: '562',
  },
  {
    country: 'Nigeria',
    iso2: 'NG',
    iso3: 'NGA',
    numeric: '566',
  },
  {
    country: 'Niue',
    iso2: 'NU',
    iso3: 'NIU',
    numeric: '570',
  },
  {
    country: 'Norfolk Island',
    iso2: 'NF',
    iso3: 'NFK',
    numeric: '574',
  },
  {
    country: 'Northern Mariana Islands (the)',
    iso2: 'MP',
    iso3: 'MNP',
    numeric: '580',
  },
  {
    country: 'Norway',
    iso2: 'NO',
    iso3: 'NOR',
    numeric: '578',
  },
  {
    country: 'Oman',
    iso2: 'OM',
    iso3: 'OMN',
    numeric: '512',
  },
  {
    country: 'Pakistan',
    iso2: 'PK',
    iso3: 'PAK',
    numeric: '586',
  },
  {
    country: 'Palau',
    iso2: 'PW',
    iso3: 'PLW',
    numeric: '585',
  },
  {
    country: 'Palestine, State of',
    iso2: 'PS',
    iso3: 'PSE',
    numeric: '275',
  },
  {
    country: 'Panama',
    iso2: 'PA',
    iso3: 'PAN',
    numeric: '591',
  },
  {
    country: 'Papua New Guinea',
    iso2: 'PG',
    iso3: 'PNG',
    numeric: '598',
  },
  {
    country: 'Paraguay',
    iso2: 'PY',
    iso3: 'PRY',
    numeric: '600',
  },
  {
    country: 'Peru',
    iso2: 'PE',
    iso3: 'PER',
    numeric: '604',
  },
  {
    country: 'Philippines (the)',
    iso2: 'PH',
    iso3: 'PHL',
    numeric: '608',
  },
  {
    country: 'Pitcairn',
    iso2: 'PN',
    iso3: 'PCN',
    numeric: '612',
  },
  {
    country: 'Poland',
    iso2: 'PL',
    iso3: 'POL',
    numeric: '616',
  },
  {
    country: 'Portugal',
    iso2: 'PT',
    iso3: 'PRT',
    numeric: '620',
  },
  {
    country: 'Puerto Rico',
    iso2: 'PR',
    iso3: 'PRI',
    numeric: '630',
  },
  {
    country: 'Qatar',
    iso2: 'QA',
    iso3: 'QAT',
    numeric: '634',
  },
  {
    country: 'R&eacute;union',
    iso2: 'RE',
    iso3: 'REU',
    numeric: '638',
  },
  {
    country: 'Romania',
    iso2: 'RO',
    iso3: 'ROU',
    numeric: '642',
  },
  {
    country: 'Russian Federation (the)',
    iso2: 'RU',
    iso3: 'RUS',
    numeric: '643',
  },
  {
    country: 'Rwanda',
    iso2: 'RW',
    iso3: 'RWA',
    numeric: '646',
  },
  {
    country: 'Saint Barth&eacute;lemy',
    iso2: 'BL',
    iso3: 'BLM',
    numeric: '652',
  },
  {
    country: 'Saint Helena, Ascension and Tristan da Cunha',
    iso2: 'SH',
    iso3: 'SHN',
    numeric: '654',
  },
  {
    country: 'Saint Kitts and Nevis',
    iso2: 'KN',
    iso3: 'KNA',
    numeric: '659',
  },
  {
    country: 'Saint Lucia',
    iso2: 'LC',
    iso3: 'LCA',
    numeric: '662',
  },
  {
    country: 'Saint Martin (French part)',
    iso2: 'MF',
    iso3: 'MAF',
    numeric: '663',
  },
  {
    country: 'Saint Pierre and Miquelon',
    iso2: 'PM',
    iso3: 'SPM',
    numeric: '666',
  },
  {
    country: 'Saint Vincent and the Grenadines',
    iso2: 'VC',
    iso3: 'VCT',
    numeric: '670',
  },
  {
    country: 'Samoa',
    iso2: 'WS',
    iso3: 'WSM',
    numeric: '882',
  },
  {
    country: 'San Marino',
    iso2: 'SM',
    iso3: 'SMR',
    numeric: '674',
  },
  {
    country: 'Sao Tome and Principe',
    iso2: 'ST',
    iso3: 'STP',
    numeric: '678',
  },
  {
    country: 'Saudi Arabia',
    iso2: 'SA',
    iso3: 'SAU',
    numeric: '682',
  },
  {
    country: 'Senegal',
    iso2: 'SN',
    iso3: 'SEN',
    numeric: '686',
  },
  {
    country: 'Serbia',
    iso2: 'RS',
    iso3: 'SRB',
    numeric: '688',
  },
  {
    country: 'Seychelles',
    iso2: 'SC',
    iso3: 'SYC',
    numeric: '690',
  },
  {
    country: 'Sierra Leone',
    iso2: 'SL',
    iso3: 'SLE',
    numeric: '694',
  },
  {
    country: 'Singapore',
    iso2: 'SG',
    iso3: 'SGP',
    numeric: '702',
  },
  {
    country: 'Sint Maarten (Dutch part)',
    iso2: 'SX',
    iso3: 'SXM',
    numeric: '534',
  },
  {
    country: 'Slovakia',
    iso2: 'SK',
    iso3: 'SVK',
    numeric: '703',
  },
  {
    country: 'Slovenia',
    iso2: 'SI',
    iso3: 'SVN',
    numeric: '705',
  },
  {
    country: 'Solomon Islands',
    iso2: 'SB',
    iso3: 'SLB',
    numeric: '090',
  },
  {
    country: 'Somalia',
    iso2: 'SO',
    iso3: 'SOM',
    numeric: '706',
  },
  {
    country: 'South Africa',
    iso2: 'ZA',
    iso3: 'ZAF',
    numeric: '710',
  },
  {
    country: 'South Georgia and the South Sandwich Islands',
    iso2: 'GS',
    iso3: 'SGS',
    numeric: '239',
  },
  {
    country: 'South Sudan',
    iso2: 'SS',
    iso3: 'SSD',
    numeric: '728',
  },
  {
    country: 'Spain',
    iso2: 'ES',
    iso3: 'ESP',
    numeric: '724',
  },
  {
    country: 'Sri Lanka',
    iso2: 'LK',
    iso3: 'LKA',
    numeric: '144',
  },
  {
    country: 'Sudan (the)',
    iso2: 'SD',
    iso3: 'SDN',
    numeric: '729',
  },
  {
    country: 'Suriname',
    iso2: 'SR',
    iso3: 'SUR',
    numeric: '740',
  },
  {
    country: 'Svalbard and Jan Mayen',
    iso2: 'SJ',
    iso3: 'SJM',
    numeric: '744',
  },
  {
    country: 'Sweden',
    iso2: 'SE',
    iso3: 'SWE',
    numeric: '752',
  },
  {
    country: 'Switzerland',
    iso2: 'CH',
    iso3: 'CHE',
    numeric: '756',
  },
  {
    country: 'Syrian Arab Republic',
    iso2: 'SY',
    iso3: 'SYR',
    numeric: '760',
  },
  {
    country: 'Taiwan (Province of China)',
    iso2: 'TW',
    iso3: 'TWN',
    numeric: '158',
  },
  {
    country: 'Tajikistan',
    iso2: 'TJ',
    iso3: 'TJK',
    numeric: '762',
  },
  {
    country: 'Tanzania, United Republic of',
    iso2: 'TZ',
    iso3: 'TZA',
    numeric: '834',
  },
  {
    country: 'Thailand',
    iso2: 'TH',
    iso3: 'THA',
    numeric: '764',
  },
  {
    country: 'Timor-Leste',
    iso2: 'TL',
    iso3: 'TLS',
    numeric: '626',
  },
  {
    country: 'Togo',
    iso2: 'TG',
    iso3: 'TGO',
    numeric: '768',
  },
  {
    country: 'Tokelau',
    iso2: 'TK',
    iso3: 'TKL',
    numeric: '772',
  },
  {
    country: 'Tonga',
    iso2: 'TO',
    iso3: 'TON',
    numeric: '776',
  },
  {
    country: 'Trinidad and Tobago',
    iso2: 'TT',
    iso3: 'TTO',
    numeric: '780',
  },
  {
    country: 'Tunisia',
    iso2: 'TN',
    iso3: 'TUN',
    numeric: '788',
  },
  {
    country: 'Turkey',
    iso2: 'TR',
    iso3: 'TUR',
    numeric: '792',
  },
  {
    country: 'Turkmenistan',
    iso2: 'TM',
    iso3: 'TKM',
    numeric: '795',
  },
  {
    country: 'Turks and Caicos Islands (the)',
    iso2: 'TC',
    iso3: 'TCA',
    numeric: '796',
  },
  {
    country: 'Tuvalu',
    iso2: 'TV',
    iso3: 'TUV',
    numeric: '798',
  },
  {
    country: 'Uganda',
    iso2: 'UG',
    iso3: 'UGA',
    numeric: '800',
  },
  {
    country: 'Ukraine',
    iso2: 'UA',
    iso3: 'UKR',
    numeric: '804',
  },
  {
    country: 'United Arab Emirates (the)',
    iso2: 'AE',
    iso3: 'ARE',
    numeric: '784',
  },
  {
    country: 'United Kingdom of Great Britain and Northern Ireland (the)',
    iso2: 'GB',
    iso3: 'GBR',
    numeric: '826',
  },
  {
    country: 'United States Minor Outlying Islands (the)',
    iso2: 'UM',
    iso3: 'UMI',
    numeric: '581',
  },
  {
    country: 'United States of America (the)',
    iso2: 'US',
    iso3: 'USA',
    numeric: '840',
  },
  {
    country: 'Uruguay',
    iso2: 'UY',
    iso3: 'URY',
    numeric: '858',
  },
  {
    country: 'Uzbekistan',
    iso2: 'UZ',
    iso3: 'UZB',
    numeric: '860',
  },
  {
    country: 'Vanuatu',
    iso2: 'VU',
    iso3: 'VUT',
    numeric: '548',
  },
  {
    country: 'Venezuela (Bolivarian Republic of)',
    iso2: 'VE',
    iso3: 'VEN',
    numeric: '862',
  },
  {
    country: 'Viet Nam',
    iso2: 'VN',
    iso3: 'VNM',
    numeric: '704',
  },
  {
    country: 'Virgin Islands (British)',
    iso2: 'VG',
    iso3: 'VGB',
    numeric: '092',
  },
  {
    country: 'Virgin Islands (U.S.)',
    iso2: 'VI',
    iso3: 'VIR',
    numeric: '850',
  },
  {
    country: 'Wallis and Futuna',
    iso2: 'WF',
    iso3: 'WLF',
    numeric: '876',
  },
  {
    country: 'Western Sahara',
    iso2: 'EH',
    iso3: 'ESH',
    numeric: '732',
  },
  {
    country: 'Yemen',
    iso2: 'YE',
    iso3: 'YEM',
    numeric: '887',
  },
  {
    country: 'Zambia',
    iso2: 'ZM',
    iso3: 'ZMB',
    numeric: '894',
  },
  {
    country: 'Zimbabwe',
    iso2: 'ZW',
    iso3: 'ZWE',
    numeric: '716',
  },
];

export const getQuarterNames = (value) => {
  switch (value) {
    case 1:
      return 'Jan - Mar';
    case 2:
      return 'Apr - Jun';
    case 3:
      return 'Jul - Sep';
    case 4:
      return 'Oct - Dec';

    default:
      return '';
  }
};
